import anime from 'animejs'
import SplitText from 'vendor/SplitText'

export default class HomeOnboarding {
  constructor(el) {
    if (!el) {
      return
    }

    this.$el = el
    this.isPlayed = sessionStorage.getItem('homepage-onboarding-played');

    if (this.isPlayed) {
      this.$el.classList.add('is-completed')

      return;
    }

    this.$logo = this.$el.querySelector('[data-ref="home-onboarding.logo"]')
    this.$polygons = this.$logo.querySelectorAll('polygon')
    this.$title = this.$el.querySelector('[data-ref="home-onboarding.title"]')
    this.$top = this.$el.querySelector('[data-ref="home-onboarding.top"]')
    this.$bottom = this.$el.querySelector('[data-ref="home-onboarding.bottom"]')
    this.slogan = new SplitText(this.$title, { type: 'chars' })
    this.$content = this.$el.querySelector('.u-card__content')
    this.$mainLogo = document.querySelector('.u-nav-portal__logo')
    this.$mainNav = document.querySelector('.u-nav-portal__list')
    this.$langSwitcher = document.querySelector('.u-nav-portal .js-nav-lang')
    this.$user = document.querySelector('.u-nav-portal .js-nav-user')
    this.$navContainer = document.querySelector('.u-nav-portal')
    this.$mainQuickNav = [
      this.$mainLogo,
      this.$mainNav,
      ...document.querySelectorAll('.u-nav-quicklinks__item'),
      this.$langSwitcher,
      this.$user,
    ]

    this.play()
  }

  play() {
    const tl = anime.timeline({
      autoplay: false,
    })

    tl.add({
      targets: this.$title,
      scaleX: {
        value: [0.8, 1],
        duration: 2000,
        easing: 'easeOutCirc',
      },
      opacity: {
        value: 1,
        duration: 200,
        easing: 'easeOutQuart',
      },
    })
      .add({
        targets: this.slogan.chars,
        offset: 0,
        opacity: {
          value: 1,
          duration: 1000,
          delay: (target, index) => {
            return index * 50
          },
        },
      })
      .add({
        targets: this.$polygons,
        offset: 0,
        opacity: {
          value: 1,
          duration: 1200,
          delay: (target, index) => {
            return index * 50
          },
        },
      })
      .add({
        targets: [this.$logo, this.$title],
        opacity: {
          value: 0,
          duration: 1,
        },
      })
      .add({
        targets: [this.$top, this.$bottom],
        offset: '+=100',
        scaleY: {
          value: 0,
          duration: 600,
        },
        easing: 'easeInOutQuart',
      })
      .add({
        targets: this.$content,
        offset: '-=300',
        opacity: {
          value: 1,
          duration: 300,
        },
        translateY: {
          value: [100, 0],
          duration: 300,
        },
        easing: 'easeOutQuad',
        complete: () => {
          this.$el.classList.add('is-completed')
          // cookies.setItem('homepage-onboarding-played', true, Infinity)
          sessionStorage.setItem('homepage-onboarding-played', '1');
        },
      });

    setTimeout(() => tl.play(), 1000)
  }
}
